// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nano-card {
  margin-top: 12px !important;
  border: none !important;
  border-radius: 8px !important;
}

.mat-expansion-panel { border-top: 1.5px solid var(--app-primary) !important; }
.nano-header-content { display: table-cell; }
.header-content-width-45 { max-width: 45%; }
.header-content-width-60 { max-width: 60%; }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/nano-card-accordion/nano-card-accordion.component.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,uBAAuB,qDAAqD,EAAE;AAC9E,uBAAuB,mBAAmB,EAAE;AAC5C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE","sourcesContent":[".nano-card {\n  margin-top: 12px !important;\n  border: none !important;\n  border-radius: 8px !important;\n}\n\n.mat-expansion-panel { border-top: 1.5px solid var(--app-primary) !important; }\n.nano-header-content { display: table-cell; }\n.header-content-width-45 { max-width: 45%; }\n.header-content-width-60 { max-width: 60%; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
